module.exports = __webpack_public_path__ + "static/media/facebook.d6f40ee5.png";